import { useEffect, useState } from "react";
import { Download, ExternalLink, Loader2 } from "lucide-react";
import { api, fmtDate } from "@/lib/api";

export const INVOICE_STATUS = {
  paid: ["Payée", "bg-green-100 text-green-700"], open: ["À régler", "bg-amber-100 text-amber-800"],
  uncollectible: ["Impayée", "bg-red-100 text-red-700"], void: ["Annulée", "bg-slate-100 text-slate-500"],
};
export const money = (n, cur = "EUR") => n.toLocaleString("fr-FR", { style: "currency", currency: cur });

export const InvoiceLinks = ({ i }) => (
  <span className="inline-flex gap-3">
    {i.pdf && <a href={i.pdf} className="inline-flex items-center gap-1 text-blue-600 hover:underline" data-testid={`invoice-pdf-${i.id}`}><Download className="h-3.5 w-3.5" />PDF</a>}
    {i.hosted_url && <a href={i.hosted_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-blue-600 hover:underline" data-testid={`invoice-view-${i.id}`}>
      <ExternalLink className="h-3.5 w-3.5" />{i.status === "open" ? "Régler" : "Voir"}</a>}
  </span>
);

export const Invoices = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/billing/invoices").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  return (
    <section className="rounded-lg border border-slate-200 p-6" data-testid="billing-invoices">
      <h2 className="font-semibold mb-1">Factures</h2>
      <p className="text-sm text-slate-500 mb-4">Une facture est émise à chaque paiement et envoyée par email.</p>
      {rows === null ? <Loader2 className="h-5 w-5 animate-spin text-slate-400" /> : !rows.length ? (
        <p className="text-sm text-slate-500" data-testid="billing-invoices-empty">Aucune facture pour l'instant.</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase text-slate-500"><tr><th className="py-2">N°</th><th>Date</th><th className="text-right">Montant TTC</th><th className="pl-4">Statut</th><th /></tr></thead>
          <tbody>
            {rows.map((i) => {
              const [label, cls] = INVOICE_STATUS[i.status] || [i.status, "bg-slate-100"];
              return (
                <tr key={i.id} className="border-t border-slate-100" data-testid={`invoice-row-${i.id}`}>
                  <td className="py-2.5 font-mono text-xs">{i.number || "—"}</td>
                  <td>{fmtDate(i.date)}</td>
                  <td className="text-right font-medium">{money(i.total, i.currency)}</td>
                  <td className="pl-4"><span className={`px-2 py-0.5 rounded-full text-xs font-medium ${cls}`}>{label}</span></td>
                  <td className="text-right"><InvoiceLinks i={i} /></td>
                </tr>
              );
            })}
          </tbody>
        </table>
      )}
    </section>
  );
};
